var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
function getPureContentWidth(el) {
  const style = getComputedStyle(el), { width: totalWidth } = el.getBoundingClientRect(), paddingLeft = Number.parseFloat(style.paddingLeft), paddingRight = Number.parseFloat(style.paddingRight), borderLeft = Number.parseFloat(style.borderLeftWidth), borderRight = Number.parseFloat(style.borderRightWidth), gap = Number.parseFloat(style.columnGap);
  return {
    rawWidth: totalWidth - paddingLeft - paddingRight - borderLeft - borderRight,
    space: gap
  };
}
__name(getPureContentWidth, "getPureContentWidth");
export {
  getPureContentWidth
};
//# sourceMappingURL=utils.js.map
